var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccentLogo = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 33 36",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#CEB384",
  d: "M.929 18v18-18ZM1.876 0H0v36h1.876V0ZM6.799 0H4.923v36h1.876V0ZM21.307 23.494c-6.427 0-11.647-5.269-11.647-11.756C9.66 5.25 14.88 0 21.307 0c6.428 0 11.63 5.269 11.63 11.738 0 6.468-5.22 11.756-11.63 11.756Zm0-21.6c-5.387 0-9.771 4.425-9.771 9.862 0 5.438 4.384 9.863 9.771 9.863 5.388 0 9.771-4.425 9.771-9.863 0-5.437-4.383-9.862-9.77-9.862Z"
})));
SvgAccentLogo.viewBox = '0 0 33 36';
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccentLogo);
export default ForwardRef;